/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import ImageContainV2 from '@components/global/ImageContainV2';
import Input from '@components/form/Input';
import Button from '@components/form/Button';
import ModalImage from '@components/modal/ModalImage';
import ModalFull from '@components/modal/ModalFull';
import ModalHalf from '@components/modal/ModalHalf';
import TableMobile from '@components/table/TableMobile';
import AddImage from '@/screens/sales-activity/components/todo-list/on-going/image/AddImage';
import RemoveImage from '@/screens/sales-activity/components/todo-list/on-going/image/RemoveImage';

import { ButtonSticky } from '@components/screen/Layout';
import Colors from '@global/colors';
import { isWeb, fullWidth } from '@global/screens';
import { ARROW_SIZE } from '@/constants';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import { showAlert, showImage } from '@/store/global';
import { showPopup } from '@/store/modal';
import { logEvent } from '@global/analytics';
import { downloadFile } from '@global/helpers';
import Toast from 'react-native-toast-message';

const dimension = Dimensions.get('screen');
const imageSize = 100;
const imageStyle = {
  position: 'relative',
  width: imageSize,
  height: imageSize,
  borderRadius: 4,
  overflow: 'hidden',
};

const MemoImage = React.memo(({ uri = '' }) => {
  return (
    <Image
      style={{ width: imageSize, height: imageSize }}
      width={imageSize}
      height={imageSize}
      source={{ uri }}
    />
  );
});

const TodoCustomerDisplay = ({
  containerHeight = 0,
  detailData = {},
  detailTodo = {},
  localPayload = null,
  onSubmit = () => {},
  onSaveDraft = () => {},
  resetTab = () => {},
}) => {
  const dispatch = useDispatch();
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const userData = useSelector((state) => state.auth.user);
  const isMerchandiser = userData?.role?.code === 'merchandiser';
  // B2B-5929: promotor only uploads Regular Display (customer_before_visit)
  const isPromotor = userData?.role?.code === 'promotor';
  const [payloadBeforeImage, setPayloadBeforeImage] = useState([]);
  const [payloadAfterImage, setPayloadAfterImage] = useState([]);
  const [payloadEndGondolaImage, setPayloadEndGondolaImage] = useState([]);
  const [payloadStandeeImage, setPayloadStandeeImage] = useState([]);
  const [payloadCocImage, setPayloadCocImage] = useState([]);
  const [imageAfterSubmit, setImageAfterSubmit] = useState({
    uri: '',
    text: '',
    url: '',
  });
  const [imageBeforeSubmit, setImageBeforeSubmit] = useState({
    uri: '',
    text: '',
    url: '',
  });
  const [editIndex, setEditIndex] = useState(-1);
  const [editBeforeIndex, setEditBeforeIndex] = useState(-1);
  const [showPlanogram, setShowPlanogram] = useState(false);
  const [step, setStep] = useState(1);
  const [planograms, setPlanograms] = useState([]);
  const [shelves, setShelves] = useState([]);
  const [selectedPlanogram, setSelectedPlanogram] = useState({
    planogram: '',
    shelve: '',
  });
  const [uploading, setUploading] = useState({
    after: false,
    before: false,
  });
  const [params, setParams] = useState({
    skip: 0,
    limit: 15,
  });
  const [totalData, setTotalData] = useState(0);
  const [keyword, setKeyword] = useState('');

  const isUploading = uploading.before || uploading.after;

  const getPlanogram = useApi(MsB2b.getPlanogram);
  const getPlanogramCount = useApi(MsB2b.getPlanogramCount);

  const buildImageEntry = (img, defaultText = '') => {
    const url = typeof img === 'string' ? img : img?.url || img?.uri || '';
    const uri = typeof img === 'string' ? img : img?.uri || img?.url || '';
    // B2B-5776: reuse the existing _localFile when there is one. The draft only
    // stores filename/type inside _localFile, so rebuilding it from the
    // top-level fields loses them on every autosave round-trip.
    const localFile = img?._localFile || {
      uri,
      filename: img?.filename,
      type: img?.type,
      mimeType: img?.mimeType,
    };
    return {
      text: img?.text || defaultText,
      url,
      ...(uri && !uri.startsWith('http') ? { _localFile: localFile } : {}),
    };
  };

  const onSubmitCustomerDisplay = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        more_info: {
          attachments: [],
        },
      };
      if (payloadBeforeImage && payloadBeforeImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_before_visit',
          name: 'customer_display',
          image: payloadBeforeImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadAfterImage && payloadAfterImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_after_visit',
          name: 'customer_display',
          image: payloadAfterImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadEndGondolaImage && payloadEndGondolaImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_end_gondola',
          name: 'customer_display',
          image: payloadEndGondolaImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadStandeeImage && payloadStandeeImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_standee',
          name: 'customer_display',
          image: payloadStandeeImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadCocImage && payloadCocImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_coc',
          name: 'customer_display',
          image: payloadCocImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      logEvent({
        eventName: 'submit_activity',
        data: {
          activity_id: detailData?._id,
          task_id: detailTodo?._id,
          type: 'customer_display',
          payload: JSON.stringify(payload),
        },
        dataKey: 'detail',
      });
      await onSubmit({
        targetType: 'customer_display',
        taskId: detailTodo?._id,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      resetTab();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!detailTodo?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-customer-display-validation',
        }),
      );
    }
  };

  const getPlanogramList = async (val = null) => {
    const filter = {};
    if (val) {
      setKeyword(val);
      filter['account_group.code'] = { $regex: val, $options: 'i' };
    }
    try {
      if (params.skip == 0) {
        const responseCount = await getPlanogramCount.request({
          params: { filter },
        });
        if (responseCount?.data?.data) {
          setTotalData(responseCount.data.data);
        }
      }

      const response = await getPlanogram.request({
        params: { ...params, filter },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        setPlanograms(response.data.data);
      } else {
        setPlanograms([]);
      }
    } catch (err) {
      setPlanograms([]);
    }
  };

  const onLoadMore = async (newSkip) => {
    setParams((prevState) => ({
      ...prevState,
      skip: newSkip,
    }));
    try {
      const filter = {};
      if (keyword) {
        filter['account_group.code'] = { $regex: keyword, $options: 'i' };
      }

      const response = await getPlanogram.request({
        params: { ...params, skip: newSkip, filter },
      });
      if (response?.data?.data?.length) {
        const new_response = response.data.data;
        setPlanograms(planograms.concat(new_response));
      }
    } catch (error) {
      console.log('error load more planogram', error);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setUploading({
        after: false,
        before: false,
      });
      const localAttachments =
        localPayload?.more_info?.attachments || localPayload?.attachments || [];
      const attachments =
        localAttachments?.length && localAttachments[0]?.type
          ? localAttachments
          : detailTodo?.more_info?.attachments || [];
      if (attachments?.length) {
        const after = attachments.find((a) => a.type == 'customer_after_visit');
        if (after) {
          const images = after.image.map((a) => ({
            ...a,
            url: a.url,
            text: a.text || '',
            uri: a.url,
          }));
          setPayloadAfterImage(images);
        }
        const before = attachments.find(
          (a) => a.type == 'customer_before_visit',
        );
        if (before) {
          const images = before.image.map((a) => ({
            ...a,
            uri: a.url,
            url: a.url,
          }));
          setPayloadBeforeImage(images);
        }
        const endGondola = attachments.find(
          (a) => a.type == 'customer_end_gondola',
        );
        if (endGondola) {
          const images = endGondola.image.map((a) => ({
            ...a,
            uri: a.url,
            url: a.url,
          }));
          setPayloadEndGondolaImage(images);
        }
        const standee = attachments.find((a) => a.type == 'customer_standee');
        if (standee) {
          const images = standee.image.map((a) => ({
            ...a,
            uri: a.url,
            url: a.url,
          }));
          setPayloadStandeeImage(images);
        }
        const coc = attachments.find((a) => a.type == 'customer_coc');
        if (coc) {
          const images = coc.image.map((a) => ({
            ...a,
            uri: a.url,
            url: a.url,
          }));
          setPayloadCocImage(images);
        }
      }
      getPlanogramList();
    }
    return () => {
      mounted = false;
    };
  }, [detailTodo, localPayload]);

  const saveDraftRef = React.useRef(onSaveDraft);

  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const payload = {
        more_info: {
          attachments: [],
        },
      };
      if (payloadBeforeImage && payloadBeforeImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_before_visit',
          name: 'customer_display',
          image: payloadBeforeImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadAfterImage && payloadAfterImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_after_visit',
          name: 'customer_display',
          image: payloadAfterImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadEndGondolaImage && payloadEndGondolaImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_end_gondola',
          name: 'customer_display',
          image: payloadEndGondolaImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadStandeeImage && payloadStandeeImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_standee',
          name: 'customer_display',
          image: payloadStandeeImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      if (payloadCocImage && payloadCocImage.length) {
        payload.more_info.attachments.push({
          type: 'customer_coc',
          name: 'customer_display',
          image: payloadCocImage.map((img) =>
            buildImageEntry(img, img?.text || ''),
          ),
        });
      }
      saveDraftRef.current({
        targetType: 'customer_display',
        taskId: detailTodo?._id,
        payload,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [
    payloadBeforeImage,
    payloadAfterImage,
    payloadEndGondolaImage,
    payloadStandeeImage,
    payloadCocImage,
    detailTodo?._id,
  ]);

  const NoData = () => {
    return (
      <View
        style={{ width: '100%', paddingHorizontal: 20, paddingVertical: 15 }}>
        <SociollaText>No data</SociollaText>
      </View>
    );
  };

  const cacheImage = (raw, type) => {
    if (type == 'before') {
      setPayloadBeforeImage((prev) => [...prev, raw]);
    } else {
      setPayloadAfterImage((prev) => [...prev, raw]);
    }
  };

  const BeforeImage = useMemo(() => {
    return payloadBeforeImage.length
      ? payloadBeforeImage.map((item, idx) => (
          <View style={[imageStyle, styles.imageItem]} key={idx}>
            <RemoveImage
              index={idx}
              data={payloadBeforeImage}
              setData={(val) => setPayloadBeforeImage(val)}
            />
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: { uri: item.uri },
                    text: item.text,
                    ...(isMerchandiser
                      ? {
                          onEdit: () => {
                            setEditBeforeIndex(idx);
                            setImageBeforeSubmit(item);
                          },
                        }
                      : {}),
                  }),
                );
              }}>
              <MemoImage uri={item.uri} />
            </TouchableOpacity>
          </View>
        ))
      : false;
  }, [imageStyle, imageSize, payloadBeforeImage, isMerchandiser]);

  const AddBeforeImage = useMemo(() => {
    return payloadBeforeImage.length < 15 ? (
      <AddImage
        data={payloadBeforeImage}
        setData={(val) => {
          if (val?.uri) {
            if (isMerchandiser) {
              setImageBeforeSubmit({ ...val, text: imageBeforeSubmit.text });
            } else {
              setPayloadBeforeImage((prev) => [...prev, { ...val, text: '' }]);
            }
          }
        }}
        disabled={isUploading}
        loadingCallback={(val) => setUploading({ ...uploading, before: val })}
        additional={{
          activity: detailData,
          task: detailTodo,
          showImageOption: true,
          isMultipleImage: true,
          limit: 15,
        }}
      />
    ) : (
      false
    );
  }, [
    payloadBeforeImage,
    imageBeforeSubmit,
    isUploading,
    uploading,
    isMerchandiser,
  ]);

  const AfterImage = useMemo(() => {
    return payloadAfterImage.length
      ? payloadAfterImage.map((item, idx) => (
          <View style={[imageStyle, styles.imageItem]} key={idx}>
            <RemoveImage
              index={idx}
              data={payloadAfterImage}
              setData={(val) => setPayloadAfterImage(val)}
            />
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: { uri: item.uri },
                    text: item.text,
                    onEdit: () => {
                      setEditIndex(idx);
                      setImageAfterSubmit(item);
                    },
                  }),
                );
              }}>
              <MemoImage uri={item.uri} />
            </TouchableOpacity>
          </View>
        ))
      : false;
  }, [imageStyle, imageSize, payloadAfterImage]);

  const AddAfterImage = useMemo(() => {
    return payloadAfterImage.length < 15 ? (
      <AddImage
        data={payloadAfterImage}
        setData={(val) => {
          if (val?.uri) {
            setImageAfterSubmit({ ...val, text: imageAfterSubmit.text });
          }
        }}
        disabled={isUploading}
        loadingCallback={(val) => setUploading({ ...uploading, after: val })}
        additional={{
          activity: detailData,
          task: detailTodo,
          showImageOption: true,
        }}
      />
    ) : (
      false
    );
  }, [payloadAfterImage, imageAfterSubmit, isUploading, uploading]);

  const EndGondolaImage = useMemo(() => {
    return payloadEndGondolaImage.length
      ? payloadEndGondolaImage.map((item, idx) => (
          <View style={[imageStyle, styles.imageItem]} key={idx}>
            <RemoveImage
              index={idx}
              data={payloadEndGondolaImage}
              setData={(val) => setPayloadEndGondolaImage(val)}
            />
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: { uri: item.uri },
                    text: item.text,
                  }),
                );
              }}>
              <MemoImage uri={item.uri} />
            </TouchableOpacity>
          </View>
        ))
      : false;
  }, [imageStyle, imageSize, payloadEndGondolaImage]);

  const AddEndGondolaImage = useMemo(() => {
    return payloadEndGondolaImage.length < 5 ? (
      <AddImage
        data={payloadEndGondolaImage}
        setData={(val) => {
          if (val?.uri) {
            setPayloadEndGondolaImage((prev) => [
              ...prev,
              { ...val, text: '' },
            ]);
          }
        }}
        disabled={isUploading}
        loadingCallback={(val) => setUploading({ ...uploading, before: val })}
        additional={{
          activity: detailData,
          task: detailTodo,
          showImageOption: true,
          isMultipleImage: true,
          limit: 5,
        }}
      />
    ) : (
      false
    );
  }, [payloadEndGondolaImage, isUploading, uploading]);

  const StandeeImage = useMemo(() => {
    return payloadStandeeImage.length
      ? payloadStandeeImage.map((item, idx) => (
          <View style={[imageStyle, styles.imageItem]} key={idx}>
            <RemoveImage
              index={idx}
              data={payloadStandeeImage}
              setData={(val) => setPayloadStandeeImage(val)}
            />
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: { uri: item.uri },
                    text: item.text,
                  }),
                );
              }}>
              <MemoImage uri={item.uri} />
            </TouchableOpacity>
          </View>
        ))
      : false;
  }, [imageStyle, imageSize, payloadStandeeImage]);

  const AddStandeeImage = useMemo(() => {
    return payloadStandeeImage.length < 5 ? (
      <AddImage
        data={payloadStandeeImage}
        setData={(val) => {
          if (val?.uri) {
            setPayloadStandeeImage((prev) => [...prev, { ...val, text: '' }]);
          }
        }}
        disabled={isUploading}
        loadingCallback={(val) => setUploading({ ...uploading, before: val })}
        additional={{
          activity: detailData,
          task: detailTodo,
          showImageOption: true,
          isMultipleImage: true,
          limit: 5,
        }}
      />
    ) : (
      false
    );
  }, [payloadStandeeImage, isUploading, uploading]);

  const CocImage = useMemo(() => {
    return payloadCocImage.length
      ? payloadCocImage.map((item, idx) => (
          <View style={[imageStyle, styles.imageItem]} key={idx}>
            <RemoveImage
              index={idx}
              data={payloadCocImage}
              setData={(val) => setPayloadCocImage(val)}
            />
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: { uri: item.uri },
                    text: item.text,
                  }),
                );
              }}>
              <MemoImage uri={item.uri} />
            </TouchableOpacity>
          </View>
        ))
      : false;
  }, [imageStyle, imageSize, payloadCocImage]);

  const AddCocImage = useMemo(() => {
    return payloadCocImage.length < 5 ? (
      <AddImage
        data={payloadCocImage}
        setData={(val) => {
          if (val?.uri) {
            setPayloadCocImage((prev) => [...prev, { ...val, text: '' }]);
          }
        }}
        disabled={isUploading}
        loadingCallback={(val) => setUploading({ ...uploading, before: val })}
        additional={{
          activity: detailData,
          task: detailTodo,
          showImageOption: true,
          isMultipleImage: true,
          limit: 5,
        }}
      />
    ) : (
      false
    );
  }, [payloadCocImage, isUploading, uploading]);

  const openPDF = async (url) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    if (url) {
      downloadFile(url, 'pdf-section', 'pdf', true);
      try {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'File Downloading', type: 'success' });
      } catch (err) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } else {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  return (
    <View testID="todo-customer-display-container" style={styles.pageContainer}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ width: '100%', height: containerHeight }}
        contentContainerStyle={styles.scrollContent}>
        <View style={styles.introCard}>
          <SociollaText type="bold" style={styles.introTitle}>
            Customer Display
          </SociollaText>
          <SociollaText style={styles.introDescription}>
            Upload picture of customer's product display before and after your
            visit.
          </SociollaText>
        </View>

        <View style={styles.sectionCard}>
          <View style={styles.sectionHeader}>
            <SociollaText type="medium" style={styles.sectionTitle}>
              {isMerchandiser || isPromotor
                ? 'Regular Display'
                : 'Before Visit'}
            </SociollaText>
            <SociollaText style={styles.sectionCountText}>
              {payloadBeforeImage.length}/15
            </SociollaText>
          </View>
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.imageRowScroll}
            contentContainerStyle={styles.imageRow}>
            {AddBeforeImage ? (
              <View style={[imageStyle, styles.imageItem]}>
                {AddBeforeImage}
              </View>
            ) : null}
            {BeforeImage}
          </ScrollView>
        </View>

        {!isPromotor && (
          <React.Fragment>
            <View style={[styles.sectionCard, styles.afterSection]}>
              <View style={styles.sectionHeader}>
                <SociollaText type="bold" style={styles.sectionTitle}>
                  {isMerchandiser ? 'Additional Display' : 'After Visit'}
                </SociollaText>
                <SociollaText style={styles.sectionCountText}>
                  {payloadAfterImage.length}/15
                </SociollaText>
              </View>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={styles.imageRowScroll}
                contentContainerStyle={styles.imageRow}>
                {AddAfterImage ? (
                  <View style={[imageStyle, styles.imageItem]}>
                    {AddAfterImage}
                  </View>
                ) : null}
                {AfterImage}
              </ScrollView>
            </View>

            <View style={styles.sectionCard}>
              <View style={styles.sectionHeader}>
                <SociollaText type="medium" style={styles.sectionTitle}>
                  End Gondola
                </SociollaText>
                <SociollaText style={styles.sectionCountText}>
                  {payloadEndGondolaImage.length}/5
                </SociollaText>
              </View>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={styles.imageRowScroll}
                contentContainerStyle={styles.imageRow}>
                {AddEndGondolaImage ? (
                  <View style={[imageStyle, styles.imageItem]}>
                    {AddEndGondolaImage}
                  </View>
                ) : null}
                {EndGondolaImage}
              </ScrollView>
            </View>

            <View style={styles.sectionCard}>
              <View style={styles.sectionHeader}>
                <SociollaText type="medium" style={styles.sectionTitle}>
                  Standee
                </SociollaText>
                <SociollaText style={styles.sectionCountText}>
                  {payloadStandeeImage.length}/5
                </SociollaText>
              </View>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={styles.imageRowScroll}
                contentContainerStyle={styles.imageRow}>
                {AddStandeeImage ? (
                  <View style={[imageStyle, styles.imageItem]}>
                    {AddStandeeImage}
                  </View>
                ) : null}
                {StandeeImage}
              </ScrollView>
            </View>

            <View style={styles.sectionCard}>
              <View style={styles.sectionHeader}>
                <SociollaText type="medium" style={styles.sectionTitle}>
                  COC
                </SociollaText>
                <SociollaText style={styles.sectionCountText}>
                  {payloadCocImage.length}/5
                </SociollaText>
              </View>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={styles.imageRowScroll}
                contentContainerStyle={styles.imageRow}>
                {AddCocImage ? (
                  <View style={[imageStyle, styles.imageItem]}>
                    {AddCocImage}
                  </View>
                ) : null}
                {CocImage}
              </ScrollView>
            </View>
          </React.Fragment>
        )}
      </ScrollView>
      <ButtonSticky
        show={!isUploading}
        customHost="modal-sticky-button"
        buttons={[
          {
            title: 'Planogram Guideline',
            type: 'default',
            onPress: () => setShowPlanogram(true),
          },
          {
            title: isUploading ? 'Uploading...' : 'Submit Customer Display',
            disabled:
              !payloadBeforeImage.length || isLoadingGlobal || isUploading
                ? true
                : false,
            onPress: () => onSubmitCustomerDisplay(),
          },
        ]}
      />

      <ModalFull
        testID="todo-customer-display-planogram-modal"
        title={
          step == 1
            ? 'Planogram Guideline'
            : step == 2
            ? 'Select Planogram'
            : `${selectedPlanogram.shelve?.name}`
        }
        noPortalSticky
        show={showPlanogram}
        back={isWeb ? false : true}
        width={650}
        onClose={() => {
          if (step == 1) {
            setShowPlanogram(false);
          } else if (step == 2) {
            setStep(1);
            setSelectedPlanogram({
              planogram: '',
              shelve: '',
            });
          } else if (step == 3) {
            setStep(2);
            setSelectedPlanogram({ ...selectedPlanogram, shelve: '' });
          }
        }}>
        <View style={{ width: '100%' }}>
          {step == 1 ? (
            <TableMobile
              placeholder="Search by Account Group Code"
              onSearch={getPlanogramList}
              tableData={planograms}
              skip={params.skip}
              limit={params.limit}
              totalData={totalData}
              withLoadMore
              noResetOnRefresh
              withFetch
              onLoadMore={onLoadMore}
              renderItem={({ data, index }) => (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={styles.planogramItem}
                  onPress={() => {
                    setSelectedPlanogram({
                      ...selectedPlanogram,
                      planogram: data?.account_group?.code,
                    });
                    setShelves(data?.shelves?.length ? data.shelves : []);
                    setStep(2);
                  }}
                  key={index}>
                  <SociollaText type="medium">
                    {data?.account_group?.code ? data.account_group.code : '-'}
                  </SociollaText>
                  <Image
                    style={[ARROW_SIZE, { transform: [{ rotate: '-90deg' }] }]}
                    width={ARROW_SIZE.width}
                    height={ARROW_SIZE.height}
                    svg={true}
                    source={require('@assets/img/icons/arrow-down-grey.svg')}
                  />
                </TouchableOpacity>
              )}
            />
          ) : step == 2 ? (
            <View style={{ width: '100%' }}>
              {shelves?.length ? (
                shelves.map((item, idx) => (
                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={styles.planogramItem}
                    onPress={() => {
                      let fileType = '';
                      const fileExtension = item.url
                        .split('.')
                        .pop()
                        .toLowerCase();
                      if (
                        ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)
                      ) {
                        fileType = 'image';
                      } else if (fileExtension === 'pdf') {
                        fileType = 'pdf';
                      }
                      const newItem = {
                        ...item,
                        type: fileType,
                      };
                      setSelectedPlanogram({
                        ...selectedPlanogram,
                        shelve: newItem,
                      });
                      setStep(3);
                    }}
                    key={idx}>
                    <SociollaText type="medium">
                      {item?.name ? item.name : 'Planogram Name'}
                    </SociollaText>
                    <Image
                      style={[
                        ARROW_SIZE,
                        { transform: [{ rotate: '-90deg' }] },
                      ]}
                      width={ARROW_SIZE.width}
                      height={ARROW_SIZE.height}
                      svg={true}
                      source={require('@assets/img/icons/arrow-down-grey.svg')}
                    />
                  </TouchableOpacity>
                ))
              ) : (
                <NoData />
              )}
            </View>
          ) : selectedPlanogram.shelve?.url &&
            selectedPlanogram.shelve?.type === 'image' ? (
            <TouchableOpacity
              onPress={() => {
                dispatch(
                  showImage({
                    isModal: true,
                    url: selectedPlanogram.shelve.url,
                  }),
                );
              }}>
              <ImageContainV2
                source={selectedPlanogram.shelve.url}
                style={{ width: fullWidth }}
              />
            </TouchableOpacity>
          ) : selectedPlanogram.shelve?.url &&
            selectedPlanogram.shelve?.type === 'pdf' ? (
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => openPDF(selectedPlanogram.shelve.url)}
              style={styles.pdfbox}>
              <Image
                style={{ width: 35, height: 43 }}
                width={35}
                height={43}
                source={require('@assets/img/icons/pdf-download.svg')}
              />
              <SociollaText style={styles.pdfTitle}>
                {selectedPlanogram.shelve.name}
              </SociollaText>
            </TouchableOpacity>
          ) : (
            <NoData />
          )}
          <ModalImage />
        </View>
      </ModalFull>

      <ModalHalf
        testID="todo-customer-display-after-image-modal"
        title="Add Image Description"
        visible={imageAfterSubmit?.uri ? true : false}
        maxWidth={'100%'}
        onClose={() => {
          setEditIndex(-1);
          setImageAfterSubmit({ uri: '', text: '', url: '' });
        }}
        children={
          <View style={{ width: '100%', padding: 15 }}>
            <View style={{ width: '100%', marginBottom: 10 }}>
              <Input
                label="Description"
                isRequired
                value={imageAfterSubmit.text}
                onChangeText={(val) => {
                  setImageAfterSubmit({ ...imageAfterSubmit, text: val });
                }}
              />
            </View>
            <View style={{ width: '100%' }}>
              <Button
                rounded
                buttonStyle={{ width: '100%' }}
                disabledStyle={{ width: '100%' }}
                disabled={!imageAfterSubmit.text}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                    }}>
                    Submit
                  </SociollaText>
                }
                onPress={() => {
                  const oldImage = JSON.parse(
                    JSON.stringify(payloadAfterImage),
                  );
                  if (editIndex > -1) {
                    oldImage[editIndex].text = imageAfterSubmit.text;
                  } else {
                    oldImage.push(imageAfterSubmit);
                  }
                  setPayloadAfterImage(oldImage);
                  setImageAfterSubmit({ uri: '', text: '', url: '' });
                  setEditIndex(-1);
                }}
              />
            </View>
          </View>
        }
      />

      {isMerchandiser && (
        <ModalHalf
          testID="todo-customer-display-before-image-modal"
          title="Add Image Description"
          visible={imageBeforeSubmit?.uri ? true : false}
          maxWidth={'100%'}
          onClose={() => {
            setEditBeforeIndex(-1);
            setImageBeforeSubmit({ uri: '', text: '', url: '' });
          }}
          children={
            <View style={{ width: '100%', padding: 15 }}>
              <View style={{ width: '100%', marginBottom: 10 }}>
                <Input
                  label="Description"
                  isRequired
                  value={imageBeforeSubmit.text}
                  onChangeText={(val) => {
                    setImageBeforeSubmit({ ...imageBeforeSubmit, text: val });
                  }}
                />
              </View>
              <View style={{ width: '100%' }}>
                <Button
                  rounded
                  buttonStyle={{ width: '100%' }}
                  disabledStyle={{ width: '100%' }}
                  disabled={!imageBeforeSubmit.text}
                  title={
                    <SociollaText
                      type="bold"
                      style={{
                        fontSize: 14,
                        letterSpacing: 0.5,
                        color: Colors.white,
                      }}>
                      Submit
                    </SociollaText>
                  }
                  onPress={() => {
                    const oldImage = JSON.parse(
                      JSON.stringify(payloadBeforeImage),
                    );
                    if (editBeforeIndex > -1) {
                      oldImage[editBeforeIndex].text = imageBeforeSubmit.text;
                    } else {
                      oldImage.push(imageBeforeSubmit);
                    }
                    setPayloadBeforeImage(oldImage);
                    setImageBeforeSubmit({ uri: '', text: '', url: '' });
                    setEditBeforeIndex(-1);
                  }}
                />
              </View>
            </View>
          }
        />
      )}

      <ModalImage />
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    backgroundColor: Colors.grey16,
  },
  scrollContent: {
    padding: 15,
    paddingBottom: 230,
  },
  introCard: {
    width: '100%',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    paddingHorizontal: 14,
    paddingVertical: 12,
    marginBottom: 12,
  },
  introTitle: {
    fontSize: 16,
    color: Colors.black,
    marginBottom: 4,
  },
  introDescription: {
    fontSize: 13,
    lineHeight: 20,
    color: Colors.grey2,
  },
  sectionCard: {
    width: '100%',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    paddingHorizontal: 12,
    paddingVertical: 12,
    marginBottom: 12,
  },
  afterSection: {
    marginBottom: 12,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 13,
    color: Colors.grey2,
  },
  sectionCountText: {
    fontSize: 11,
    color: Colors.grey1,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  imageRowScroll: {
    width: '100%',
  },
  imageRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingRight: 2,
  },
  imageItem: {
    marginRight: 10,
  },
  planogramItem: {
    width: '100%',
    paddingHorizontal: 20,
    paddingVertical: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: Colors.white,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  pdfbox: {
    width: 100,
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.blue0,
    padding: 8,
    marginLeft: 16,
    marginVertical: 16,
  },
  pdfTitle: { marginTop: 10 },
});

export default React.memo(TodoCustomerDisplay, (prev, next) => prev == next);
